<template>
  <div>
    <div class="vx-row" v-if="device">
      <div class="vx-col w-full">
        <div class="article-title mb-6 text-center">
          <h1> {{$t("ReleaseContent")}} </h1>

          <div class="bg-primary text-white mt-4 p-4 rounded" v-show="!dispositivo.licence.active">
            <div> {{$t("TxtReleaseContentOne")}} </div>
            <div class="mt-4">
             {{$t("TxtReleaseContentTwo")}}
              <strong> {{$t("JustinTime")}} </strong> {{$t("TxtPaymentTwo")}}
            </div>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full sm:w-1/2 xl:w-1/4 mb-4" v-for="plan in plans" :key="plan.id">
            <div class="vx-card">
              <div class="vx-card__collapsible-content vs-con-loading__container">
                <div class="p-8 clearfix">
                  <div>
                    <h2>
                      <span>{{plan.name}}</span>
                      <img
                        v-if="plan.recurring == true"
                        src="../assets/images/elements/coroa.png"
                        width="20px;"
                        align="right"
                      />
                    </h2>
                    <small v-if="plan.discount && !plan.recurring">
                      <span class="text-grey mr-1"> {{$t("Discount")}} </span>
                      <span class="mr-1">{{plan.discount}}%</span>
                      <span>OFF</span>
                    </small>

                    <small v-if="!plan.discount && !plan.recurring">
                      <span>&nbsp;</span>
                    </small>

                    <small v-if="plan.recurring">
                      <span class="text-grey mr-1"> {{$t("RecurringSubscription")}} </span>
                    </small>
                  </div>
                  <p class="mt-2 mb-8 font-medium" v-if="plan.setup_fee == 0">
                    <sup class="text-grey" v-if="plan.discount && !plan.recurring"> {{$t("In")}} </sup>
                    <span
                      class="text-grey"
                      style="text-decoration: line-through; margin-right:15px;"
                      v-if="plan.discount && !plan.recurring"
                    >{{plan.original_price | money(plan.currency_code)}}</span>
                    <sup class="text-grey">{{$t("Per")}}</sup>
                    <span class="ml-1 text-success text-xl">{{plan.fixed_price | money(plan.currency_code)}}</span>
                  </p>
                  <p class="mt-2 mb-8 font-medium" v-if="plan.setup_fee > 0">
                    <sup class="text-grey"> {{$t("Initial")}} </sup>
                    <span class="ml-1" style="margin-right:15px;">{{plan.setup_fee | money(plan.currency_code)}}</span>
                    <sup class="text-grey">{{$t("Monthly")}}</sup>
                    <span class="ml-1 text-success text-xl">{{plan.fixed_price | money(plan.currency_code)}}</span>
                  </p>
                  <a
                    :href="`${urlSite}/checkout/payment?planId=${plan.id}&k=${key}&d=${device}&eml=${email}`"
                    class="vs-component vs-button w-full vs-button-relief includeIcon"
                    :class="plan.recurring ? 'vs-button-warning' : 'vs-button-primary'"
                  >
                    <i
                      class="vs-icon notranslate icon-scale vs-button--icon feather icon-chevrons-right null"
                      style="order: 2; margin-right: 0px; margin-left: 5px;"
                    ></i>
                    <span class="vs-button-text vs-button--text" v-if="!plan.recurring"> {{$t("BuyNow")}} </span>
                    <span class="vs-button-text vs-button--text" v-if="plan.recurring"> {{$t("SubscribeNow")}} </span>
                  </a>
                </div>
                <div class="p-2 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
                  <div class="vx-card__footer" style="padding-top:10px;">
                    <div class="flex justify-between">
                      <a :href="`https://api.whatsapp.com/send?phone=${appWhatsAppMobileNumber}`">
                        <span class="flex items-center">
                          <i class="fa fa-whatsapp"></i>
                          <span class="ml-2">WhatsApp</span>
                        </span>
                      </a>
                      <a :href="`tel:${appTelefoneNaoFormatado}`">
                        <span class="flex items-center">
                          <i class="fa fa-phone"></i>
                          <span class="ml-2">{{$t("Telephone")}}</span>
                        </span>
                      </a>
                    </div>
                    <br />
                    <img class="h-8" src="@/assets/images/pages/bandeiras-cartao.png" v-if="!plan.recurring" />
                    <img class="h-8" src="@/assets/images/pages/bandeiras-cartao-paypal.png" v-if="plan.recurring" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      plans: [],
      device: "",
      key: "",
      email: "",
      urlSite: process.env.VUE_APP_URL_COMPRA,
      dispositivo: {
        licence: {
          until: null
        }
      },
      appTelefoneNaoFormatado: process.env.VUE_APP_TELEFONE_NAO_FORMATADO,
      appWhatsAppMobileNumber: process.env.VUE_APP_WHATSAPP,
    };
  },

  mounted() {
    this.load();
  },

  methods: {
    load: function() {
      this.$api
        .get("/api/v1/mobile/device/" + this.$route.params.uid)
        .then(response => {
          this.dispositivo = response.data.data;
          this.device = btoa(
            this.dispositivo.device +
              (this.dispositivo.alias
                ? " (" + this.dispositivo.alias + ")"
                : "")
          );
        });

      this.$api
        .get("/api/v1/plans/key/" + this.$route.params.uid + (this.$route.query.ip ? '?ip=' + this.$route.query.ip : ''))
        .then(response => {
          this.key = response.data.key;
          this.email = response.data.eml;
        });

      this.$api.get("/api/v1/plans" + (this.$route.query.ip ? '?ip=' + this.$route.query.ip : '')).then(response => {
        this.plans = response.data.data.filter(i => {
          return i.product_id == this.$route.params.product_id;
        });
      });
    }
  }
};
</script>
